import { render } from "./MyBoard.vue?vue&type=template&id=2631a680"
import script from "./MyBoard.vue?vue&type=script&lang=js"
export * from "./MyBoard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__